import { getStore, setStore, keys } from '../store'

export const SUPPORTED_LOCALES = ['en', 'zh_CN']

export function normalizeLocale(locale) {
    if (locale == null || locale === '') return null
    const value = String(locale).trim()
    const lower = value.toLowerCase()
    // 路由/存储：zh_CN、en；兼容旧值 1/2、zh-CN、cn
    if (value === 'en' || lower === 'en' || value === '2' || lower === '2') return 'en'
    if (
        value === 'zh_CN' ||
        lower === 'zh_cn' ||
        lower === 'zh-cn' ||
        lower === 'cn' ||
        value === '1' ||
        lower === '1'
    ) return 'zh_CN'
    return null
}

/** 解析路由 query.lang：zh_CN / en（兼容旧值 1/2） */
export function parseLangQuery(value) {
    return normalizeLocale(value)
}

export function parseLocaleFromQuery(searchOrQuery) {
    if (searchOrQuery == null) return null

    if (typeof searchOrQuery === 'string') {
        const search = searchOrQuery.startsWith('?') ? searchOrQuery : `?${searchOrQuery}`
        const lang = new URLSearchParams(search).get('lang')
        return parseLangQuery(lang)
    }

    return parseLangQuery(searchOrQuery.lang)
}

export function toApiLang(locale) {
    const normalized = normalizeLocale(locale) || normalizeLocale(getStore(keys.lang))
    return normalized || 'zh_CN'
}

/** 公共信息等接口 / 路由 query.lang：zh_CN / en */
export function toQueryLang(locale) {
    const normalized = normalizeLocale(locale) || normalizeLocale(getStore(keys.lang)) || 'zh_CN'
    return normalized === 'en' ? 'en' : 'zh_CN'
}

export function parseLocaleFromPath(pathname) {
    const match = pathname.match(/^\/goods\/([^/?#]+)/)
    if (match) {
        return normalizeLocale(match[1])
    }
    return null
}

export function persistLocale(locale) {
    const normalized = normalizeLocale(locale)
    if (!normalized || !SUPPORTED_LOCALES.includes(normalized)) return null
    setStore(keys.lang, normalized)
    return normalized
}

export function resolveLocale(route) {
    const fromQuery = route && parseLocaleFromQuery(route.query)
    if (fromQuery) return fromQuery

    const fromParam = route && route.params && normalizeLocale(route.params.id)
    if (fromParam) return fromParam

    const fromPath = parseLocaleFromPath(window.location.pathname)
    if (fromPath) return fromPath

    const fromStore = normalizeLocale(getStore(keys.lang))
    if (fromStore) return fromStore

    return 'zh_CN'
}

export function applyDocumentLang(locale) {
    const normalized = normalizeLocale(locale) || 'zh_CN'
    if (typeof document === 'undefined') return normalized
    const html = document.documentElement
    const htmlLang = normalized === 'en' ? 'en' : 'zh'
    html.setAttribute('lang', htmlLang)
    // 固定根字号，覆盖登录页等写入的 inline font-size（避免跳转后仍为 150px+）
    html.style.fontSize = htmlLang === 'en' ? '14px' : '16px'
    return normalized
}

/** 恢复全局根字号（离开会改写 html.fontSize 的页面时调用） */
export function resetDocumentFontSize(locale) {
    return applyDocumentLang(locale || getStore(keys.lang) || 'zh_CN')
}

export function applyLocale(locale, i18n) {
    const normalized = normalizeLocale(locale) || 'zh_CN'
    persistLocale(normalized)
    applyDocumentLang(normalized)
    if (i18n) {
        i18n.locale = normalized
    }
    return normalized
}

export function getInitialLocale() {
    return resolveLocale({
        query: Object.fromEntries(new URLSearchParams(window.location.search)),
        params: {},
    })
}

export function syncLocaleFromRoute(route, i18n) {
    return applyLocale(resolveLocale(route), i18n)
}

export function applyLocaleFromRoute(route, i18n) {
    return syncLocaleFromRoute(route, i18n)
}



// WEBPACK FOOTER //
// ./src/utils/locale.js